/* eslint-disable no-console */
<template>
  <div class="main_unit">
    <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
    <div v-show="!isInitLoading">
      <div class="top_unit">
        <div class="top_name_box"><div class="mgb_10">{{brandStoreName}}</div>責任者：{{adminName}}</div>
        <div class="top_center_box"> </div>
      </div>

      <div class="mgt_40 mgl_20">
        <Message v-if="ApivalidationMessage!==''" :validationMessage="alertMessage" /><br>
        <Message :validationMessage="ApivalidationMessage" />
      </div>
      <div class="heat_stroke_option_box">
        <div class="heat_stroke_radio_button_box">
          <button @click="changeChart('bar')"
                  :class="{ 'is-active': activeBtn === 1 }">ヒートマップ</button>
          <button @click="changeChart('line')"
                  :class="{ 'is-active': activeBtn === 2 }">温度・湿度</button>
        </div>
        <div class="form-check form-check-inline wd70">
          <ul style="padding-left: 60px;">
            <li class="d-flex align-items-center"><input href="#" type="button" class="btn_csv" value="CSV出力" @click.prevent.stop="outputCsv">(※24時間分出力)</li>
          </ul>
        </div>
      </div>

      <div v-if="chartType === 'bar'" class="wd965 d-flex flex-row align-items-start" style="overflow-y:auto;">
        <HeatStrokeIndexChart style="width: 97%" :item-list="itemList" />
        <div class="wbgt-legend">
          <div class="wbgt-item danger_item">
            <div class="wbgt-badge">危 険</div>
            <div class="wbgt-text">31℃以上</div>
          </div>
          <div class="wbgt-item severe_item">
            <div class="wbgt-badge">厳重警戒</div>
            <div class="wbgt-text">28℃〜31℃</div>
          </div>
          <div class="wbgt-item alert_item">
            <div class="wbgt-badge">警 戒</div>
            <div class="wbgt-text">25℃〜28℃</div>
          </div>
          <div class="wbgt-item caution_item">
            <div class="wbgt-badge">注 意</div>
            <div class="wbgt-text">25℃未満</div>
          </div>
        </div>
      </div>
      <div v-if="chartType === 'line'" class="Temperature_content_box wd965" style="overflow-y:auto;">
        <div class="temperature_input_display left_comment" id="displaySet" style="margin: 10px auto 20px">
          <div class="temperature_lavel right_comment form-check-inline">
            <label for="displaySet">表示データ選択</label>
          </div>
          <div class="form-check form-check-inline wd70">
            <input class="form-check-input display_radio" id="displaySet_id1" name="checkdis" type="radio" value='1' v-model="temperatureSelect" @change="changeData">
            <label class="form-check-label" for="displaySet_id1">温度</label>
          </div>
          <div class="form-check form-check-inline wd70">
            <input class="form-check-input display_radio" id="displaySet_id2" name="checkdis" type="radio" value='2' v-model="temperatureSelect" @change="changeData">
            <label class="form-check-label" for="displaySet_id2">湿度</label>
          </div>
        </div>
        <HeatStrokeBarChart
            :style="newHeight"
            :chart-data="barData"
            :upperDataString="upperDataString"
            :lowerDataString="lowerDataString"
            :optionsXAxesTicksMin="optionsXAxesTicksMin"
            :optionsXAxesTicksMax="optionsXAxesTicksMax"
            :temperature-select="changeSelect"
        ></HeatStrokeBarChart>
      </div>
    </div>
    <div class="overlay" v-show="showContent">
      <div>
        <div class="modal_box wd512">
          <div class="modal_header_unit">
            <div class="modal_header_box">
              <p class="modal_header_tit">CSV出力</p>
            </div>
          </div>
          <div class="modal_content_tex">
            <p>CSV出力が完了しました。</p>
          </div>
          <div class="btn_submit">
            <a href="#" @click.prevent.stop="closeModel">OK</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeatStrokeIndexChart from '@/app/components/HeatStrokeIndexChart.vue'
import HeatStrokeBarChart from '@/app/components/HeatStrokeBarChart.vue'
export default {
  name:"HeatStrokeIndexMap",
  components: {
    HeatStrokeIndexChart,
    HeatStrokeBarChart
  },
  data() {
    return {
      isLoading:false,
      isInitLoading:true,
      ApivalidationMessage:'',
      alertMessage:'入力エラーがあります。',
      brandId: '',
      storeId: '',
      itemList: [],
      chartType:'bar',
      sensorData: [],
      barData:null,
      date:null,
      upperDataString:"",
      lowerDataString:"",
      optionsXAxesTicksMin:"",
      optionsXAxesTicksMax:"",
      senserCloarSetting:[
        '#ff0000',
        '#0000ff',
        '#e0e000',
        '#008000',
        '#00ffff',
        '#ffa500',
        '#800080',
        '#c00000',
        '#0000c0',
        '#808000',
        '#004000',
        '#00C0C0',
        '#c07500',
        '#c000c0',
        '#c0c0c0',
      ],
      activeBtn: 1,
      temperatureSelect:1,
      changeSelect:1,
      sensorKbnId:null,
      showContent:false,
    }
  },
  computed: {
    brandPath: function () {
      return this.$store.getters['brand/path']
    },
    adminName: function () {
      return this.$store.getters['store/adminName']
    },
    staffName: function () {
      return this.$store.getters['staff/name']
    },
    staffId: function () {
      return this.$store.getters['staff/staffId']
    },
    brandStoreName: function () {
      let brandName = this.$store.getters['brand/name']
      let storeName = this.$store.getters['store/name']
      if (brandName == null) {
        brandName = ''
      }
      if (storeName == null) {
        storeName = ''
      }
      return brandName + '・' + storeName
    },
    newHeight() {
      return {
        height: `${this.height}px`,
        position: 'relative'
      }
    },
  },
  created: function(){
    this.date = new Date(this.chartDateBusinessDay(new Date()));
    this.calc();
  },
  methods: {
    async calc() {

      // ブランドIDを取得
      this.brandId = this.$store.getters['brand/id'];
      // ストアIDを取得
      this.storeId = this.$store.getters['store/id'];
      this.ApivalidationMessage = '';
      var apiResponseFlg = true;
      var datetime = this.dateFormat();
      var selectBusinessDay = this.selectDateFormat(this.date);

      var url = this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store/' + this.storeId + '/heat_stroke_index?datetime=' + datetime + '&businessday=' + selectBusinessDay;
      // 温度湿度管理一覧取得API
      await this.$axios
          .get(url)
          .then(response => {
            this.sensorData = response.data.sensorList;
            this.sensorKbnId = response.data.sensorKbnId;
          })
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            apiResponseFlg = false;
            if (err.customError) {
              error = Object.assign(error, err.customError);

              if(error.code == 400){
                this.ApivalidationMessage =  error.message;
                this.scrollTop();
              }
            }
            if(error.code !== 400){
              this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
            }
          }).finally(()=> this.isInitLoading = false);
      // API処理判定
      if(apiResponseFlg){
        this.dataSet();
      }
    },
    // 表示時間の生成(現在時刻、または営業日)
    fromToDataSet(){

      var toDate = "";
      var fromDate = "";

      // グラフ表示用日付 From TO の初期化
      this.lowerDataString = "";
      this.upperDataString = "";

      // 営業日がある場合、当日の営業日かを判定し、現在時刻を使用するか判定する
      if(this.date !== null){
        var nowBusinessDay = this.chartDateBusinessDay(new Date());
        var selectBusinessDay = this.selectDateFormat(this.date);
        if(nowBusinessDay === selectBusinessDay){
          // 同じ営業日の場合、現在日時を使用
          toDate = new Date();
          fromDate = new Date();
        }
        else if(nowBusinessDay > selectBusinessDay){
          // 過去の営業日の場合、指定の営業日を使用
          let year = selectBusinessDay.substr(0,4);
          let month = selectBusinessDay.substr(5,2);
          let day = selectBusinessDay.substr(8,2);
          toDate = new Date(Number(year),Number(month)-1,Number(day),2,59)
          toDate.setDate(toDate.getDate()+1); // 営業日換算のため翌日を生成
          fromDate = new Date(Number(year),Number(month)-1,Number(day),3,0)
          fromDate.setDate(fromDate.getDate()+1); // 営業日換算のため翌日を生成
        }
      }
      else{
        // 現在時刻を基準時間として使用する。
        toDate = new Date();
        fromDate = new Date();
      }

      fromDate.setHours(fromDate.getHours()-24);

      this.setCharXAxes(fromDate, toDate);
      this.lowerDataString = this.chartDateFormat(fromDate);
      this.upperDataString = this.chartDateFormat(toDate);

    },
    setCharXAxes(fromDate, toDate){
      this.optionsXAxesTicksMin = this.chartDateFormat(fromDate);
      this.optionsXAxesTicksMax = this.chartDateFormat(toDate);
    },
    chartDateFormat(date){
      let year = date.getFullYear();
      let month = ("0" + (date.getMonth()+1)).slice(-2);
      let day = ("0" + date.getDate()).slice(-2);
      let hours = ("0" + date.getHours()).slice(-2);
      let minutes = ("0" + date.getMinutes()).slice(-2);

      let format_str = 'YYYY/MM/DD hh:mm';
      format_str = format_str.replace(/YYYY/g,year);
      format_str = format_str.replace(/MM/g,month);
      format_str = format_str.replace(/DD/g,day);
      format_str = format_str.replace(/hh/g,hours);
      format_str = format_str.replace(/mm/g,minutes);

      return format_str;
    },
    selectDateFormat(date){
      let year = date.getFullYear();
      let month = ("0" + (date.getMonth()+1)).slice(-2);
      let day = ("0" + date.getDate()).slice(-2);

      let format_str = 'YYYY/MM/DD';
      format_str = format_str.replace(/YYYY/g,year);
      format_str = format_str.replace(/MM/g,month);
      format_str = format_str.replace(/DD/g,day);

      return format_str;
    },
    async dataSet(){

      var dataSetsList = [];
      var dataSetsListObj = new Object();

      var count =0;
      var allLabelLength = 0;
      var cloerCount = 0; // 色選択用カウント

      // グラフ再描画の為、表示フラグをOFFにする
      this.reload = false;

      // 表示単位の設定
      var selectUnit = "";
      if(this.temperatureSelect == 1){
        selectUnit = "℃";
      }
      else{
        selectUnit = "％";
      }
      this.fromToDataSet();
      let itemList = [];
      for(var i = 0 ;i < this.sensorData.length ; i++){

        for (let indexOfData in this.sensorData[i].sensorHistoryList) {
          var dataLst = new Object();
          var dataByLocation = this.sensorData[i].sensorHistoryList[indexOfData]
          var dataDisList = [];
          var dataDisList2 = [];
          var dataDisList3 = [];
          var dataDisList4 = [];
          var dataDisList5 = [];
          var dataDisListTemp = [];
          var dataDisListHumi = [];
          var dataDisListTempUnit = [];
          var dataDisListHumiUnit = [];
          var locationStr = "";
          var temperatureAccidentFlg = 0;
          var sensorAccidentFlg = 0;


          for(var k =0 ; k < dataByLocation.length ; k++){
            var ojTemp = new Object();
            var ojHumi =  new Object();
            var dataByLocationObj = dataByLocation[k];
            ojTemp['x'] = dataByLocationObj.detectionDate;
            ojTemp['y'] = dataByLocationObj.temperature;
            ojHumi['x'] = dataByLocationObj.detectionDate;
            ojHumi['y'] = dataByLocationObj.humidity;
            dataDisList[k] = ojTemp;

            dataDisListTemp[k] = ojTemp;
            dataDisListHumi[k] = ojHumi;
            dataDisList2[k] = dataByLocationObj.location;
            dataDisList3[k] = this.sensorData[i].sensorId;
            dataDisList4[k] = selectUnit;
            dataDisListTempUnit[k] = "℃";
            dataDisListHumiUnit[k] = "％";
            dataDisList5[k] = dataByLocationObj.staffName;
            locationStr = dataByLocationObj.location;


            if(k+1 == dataByLocation.length) {

              var inpuotApiDataObj = new Object();
              inpuotApiDataObj['sensor_setting_id'] = dataByLocationObj.sensorSettingId;
              inpuotApiDataObj['location'] = dataByLocationObj.location;
              inpuotApiDataObj['sensor_id'] = this.sensorData[i].sensorId;
              inpuotApiDataObj['detectiondatetime'] = dataByLocationObj.detectionDate;
              inpuotApiDataObj['temperature'] = dataByLocationObj.temperature;
              inpuotApiDataObj['humidity'] = dataByLocationObj.humidity;
              itemList.push(inpuotApiDataObj);
            }
          }

          dataLst['label'] = locationStr + ":" + this.sensorData[i].sensorId;
          dataLst['data'] = dataDisList;
          dataLst['temperature'] = dataDisListTemp;
          dataLst['humidity'] = dataDisListHumi;
          dataLst['location']= dataDisList2;
          dataLst['sensorId']= dataDisList3;
          dataLst['selectUnit']= dataDisList4;
          dataLst['tempUnit'] = dataDisListTempUnit;
          dataLst['humiUnit'] = dataDisListHumiUnit;
          dataLst['staffName'] = dataDisList5;
          dataLst['sensorKbnId'] = this.sensorData[i].sensorKbnId;
          dataLst['temperatureAccidentFlg'] = temperatureAccidentFlg;
          dataLst['sensorAccidentFlg'] = sensorAccidentFlg;
          // センサーカウント15を超えた場合、配色にカウントを戻す
          if(cloerCount >= 15){
            cloerCount = 0;
          }
          dataLst['borderColor'] = this.senserCloarSetting[cloerCount];

          dataLst['borderWidth'] =1;
          dataLst['lineTension'] =0;
          dataLst['fill'] =false;
          dataLst['hidden'] = false;
          dataSetsList[count] = dataLst;
          count = count + 1;
          cloerCount = cloerCount + 1;
          allLabelLength = allLabelLength + dataLst['label'].length;
        }
      }

      dataSetsListObj['labels'] = [];
      dataSetsListObj['datasets'] = dataSetsList;
      this.itemList = itemList;
      this.barData = dataSetsListObj;
      this.tempSenserData = this.sensorData;
      if(allLabelLength <= 0) {
        this.height = this.baseHeight;
      } else {
        this.height = this.baseHeight + ((allLabelLength/70)*25);
      }
      // 描画完了まで待機
      await this.$nextTick();
    },
    async changeChart(type) {
      this.chartType = type;
      if(type === 'bar') {
        this.activeBtn = 1;
      } else {
        this.activeBtn = 2;
      }
    },
    // 手動入力ダイアログ表示時の営業日を設定
    chartDateBusinessDay(date){

      let year = date.getFullYear();
      let month = ("0" + (date.getMonth()+1)).slice(-2);
      let day = ("0" + date.getDate()).slice(-2);
      let hours = ("0" + date.getHours()).slice(-2);

      // AM00-AM03時の判定
      if(hours >= '00' && hours < '03'){

        // 年始の考慮
        if(month == '01' && day == '01'){
          var yearEndDate = new Date(date.getFullYear()-1,12,0);
          year = date.getFullYear()-1;
          month = 12;
          day = ("0" + yearEndDate.getDate()).slice(-2);

        }
        // 月末の考慮
        else if(day == '01'){
          var monthEndDate = new Date(date.getFullYear(),date.getMonth(),0);
          month = ("0" + (date.getMonth())).slice(-2);
          day = ("0" + monthEndDate.getDate()).slice(-2);
        }
        // 前日日付の営業日
        else{
          var dayBeforeDate = new Date(date.getFullYear(),date.getMonth()+1,date.getDate()-1);
          day =  ("0" + dayBeforeDate.getDate()).slice(-2);
        }
      }

      let format_str = 'YYYY/MM/DD';
      format_str = format_str.replace(/YYYY/g,year);
      format_str = format_str.replace(/MM/g,month);
      format_str = format_str.replace(/DD/g,day);

      return format_str;
    },
    async changeData() {
      var dataSetsListObj = this.barData;
      for (var k =0 ; k < dataSetsListObj['datasets'].length ; k++) {
        if(this.temperatureSelect == 1){
          dataSetsListObj['datasets'][k]['data'] = dataSetsListObj['datasets'][k]['temperature'];
          dataSetsListObj['datasets'][k]['selectUnit'] = dataSetsListObj['datasets'][k]['tempUnit'];
        } else {
          dataSetsListObj['datasets'][k]['data'] = dataSetsListObj['datasets'][k]['humidity'];
          dataSetsListObj['datasets'][k]['selectUnit'] = dataSetsListObj['datasets'][k]['humiUnit'];
        }
      }
      this.barData = dataSetsListObj;
      this.changeSelect = this.temperatureSelect
      // 描画完了まで待機
      await this.$nextTick();
    },
    async outputCsv(){
      var datetime = this.dateFormat();
      this.apivalidationMessage = '';
      var URL = this.$apiEndpoint + 'user/brand/' + this.brandId + '/store/' + this.storeId +
          '/heat_stroke/csv?datetime=' + datetime
          + '&range=' + 2
          + '&sensor_kbn_id=' + this.sensorKbnId;
      if(this.date !== null) {
        var businessDay = "";
        businessDay = this.selectDateFormat(this.date);
        URL = URL + '&businessday=' + businessDay;
      }
      await this.$axios
          .get(URL)
          .then(response => (this.csvResponseData = response))
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            if (this.auth == 4 && err.customError.code) {
              //店舗管理者のtokenエラーの場合
              this.$cookies.set('user-api-token', '', 0)
              this.$store.dispatch('store/doClear')
            }
            if (err.customError) {
              error = Object.assign(error, err.customError)
            }
            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
          }).finally(()=> this.isLoading = false)
      // CSV出力
      if(!this.commonDownloadCSV(this.csvResponseData)){
        this.apivalidationMessage =  "CSVの出力に失敗しました。";
        this.scrollTop();
      }
      else{
        this.showContent = true;
      }
    },
    dateFormat(){
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
      let day = ("0" + nowDate.getDate()).slice(-2);
      let hours = ("0" + nowDate.getHours()).slice(-2);
      let minutes = ("0" + nowDate.getMinutes()).slice(-2);
      let seconds = ("0" + nowDate.getSeconds()).slice(-2);
      let format_str = 'YYYYMMDDhhmmss'
      format_str = format_str.replace(/YYYY/g,year);
      format_str = format_str.replace(/MM/g,month);
      format_str = format_str.replace(/DD/g,day);
      format_str = format_str.replace(/hh/g,hours);
      format_str = format_str.replace(/mm/g,minutes);
      format_str = format_str.replace(/ss/g,seconds);
      return format_str;
    },
    closeModel: function(){
      this.showContent = false;
    },
  },
}
</script>